"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfigurationModeSwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _i18n = require("../../../../../Framework/i18n");
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _excluded = ["configurationModeOptions", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = function styles(theme) {
  return {
    root: {
      textTransform: 'none',
      fontSize: 15
    },
    outlined: {
      boxShadow: theme.shadows[2],
      '&:hover': {
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2]
        }
      }
    },
    label: {}
  };
};
var ConfigurationModeSwitch = exports.ConfigurationModeSwitch = function ConfigurationModeSwitch(_ref) {
  var configurationModeOptions = _ref.configurationModeOptions,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var modeOption = configurationModeOptions[0];
  return configurationModeOptions.length && /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
    targetId: "configuration_mode_switch",
    data: modeOption
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    variant: "outlined",
    fullWidth: true,
    size: "medium",
    onClick: function onClick() {
      return onChange(modeOption);
    }
  }, props), (0, _i18n.t)("configurationModeSwitch.options.".concat(modeOption))));
};
ConfigurationModeSwitch.defaultProps = {
  configurationModeOptions: []
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'ConfigurationModeSwitch'
})(ConfigurationModeSwitch);